/*
 *
 * Dashboard reducer
 *
 */

import { createReducer } from '@reduxjs/toolkit';
import {
  defaultAction,
  defaultActionSuccess,
  defaultActionError,
  fetchInformation,
  fetchInformationSuccess,
  fetchInformationError,
  getTreeToken,
  getTreeTokenSuccess,
  getTreeTokenError,
  getWalletSummary,
  getWalletSummarySuccess,
  getWalletSummaryError,
} from './actions';
import { InformationData } from '../../models/Information';
import { WalletSummaryResponse } from '../../apischema/savingwallet';

export interface DashboardState {
  data: any;
  loading: boolean;
  error: string | null;
  // Information state
  information: InformationData | null;
  informationLoading: boolean;
  informationError: string | null;
  treeToken: string | null;
  // Wallet Summary state
  walletData: WalletSummaryResponse | null;
  walletLoading: boolean;
  walletError: string | null;
}

export const initialState: DashboardState = {
  data: null,
  loading: false,
  error: null,
  // Information initial state
  information: null,
  informationLoading: false,
  informationError: null,
  treeToken: null,
  // Wallet Summary initial state
  walletData: null,
  walletLoading: false,
  walletError: null,
};

const dashboardReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(defaultAction, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(defaultActionSuccess, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
    })
    .addCase(defaultActionError, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    })
    // Information cases
    .addCase(fetchInformation, (state) => {
      state.informationLoading = true;
      state.informationError = null;
    })
    .addCase(fetchInformationSuccess, (state, action) => {
      state.informationLoading = false;
      state.information = action.payload.data;
    })
    .addCase(fetchInformationError, (state, action) => {
      state.informationLoading = false;
      state.informationError = action.payload.error;
    })

    .addCase(getTreeToken, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getTreeTokenSuccess, (state, action) => {
      state.loading = false;
      state.treeToken = action.payload.token;
      state.error = null;
    })
    .addCase(getTreeTokenError, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    })
    // Wallet Summary cases
    .addCase(getWalletSummary, (state) => {
      state.walletLoading = true;
      state.walletError = null;
    })
    .addCase(getWalletSummarySuccess, (state, action) => {
      state.walletLoading = false;
      state.walletData = action.payload.data;
      state.walletError = null;
    })
    .addCase(getWalletSummaryError, (state, action) => {
      state.walletLoading = false;
      state.walletError = action.payload.error;
    });
});

export default dashboardReducer;
